import React from 'react';
import { MerchantPdqList } from 'components';

function DashboardPdqComponent() {
    return <MerchantPdqList />;
}

export default DashboardPdqComponent;
